import React from "react";
import styled from "styled-components";

const MandatoryStar = () => {
    return <MandatoryParagraph>*</MandatoryParagraph>;
};

export default MandatoryStar;

const MandatoryParagraph = styled.p`
    font-size: 0.75rem;
    align-self: start;
    margin: 0;
`;
